import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            initOnRender: false,
            global_search: {
                visibility: false,
            }
        },

        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Keresés',
                event_name: "customClick",
                class: "btn btn btn-danger my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            }
        ],

        searchFields: [
            {
                name: "occupationHealthPartnerId",
                label: "FEÜ partner",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllPartnersToSelect,
                    formatText: function (val) {
                        return val.name;
                    },
                    formatOption: function (val) {
                        return val.name;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'name',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "appointmentFrom",
                label: "Vizsgálat dátumától",
                formSize: 3,
                formType: "date"
            },
            {
                name: "appointmentTo",
                label: "Vizsgálat dátumáig",
                formSize: 3,
                formType: "date"
            },
            {
                name: "capableStatusId",
                label: "Alkalmasság",
                formSize: 3,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCapableStatus,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "isThereRestriction",
                label: "Volt korlátozás?",
                formSize: 3,
                formType: "checkbox",
                visibility: true
            },

            {
                name: "validityFrom",
                label: "Érvényesség dátumától",
                formSize: 3,
                formType: "date"
            },
            {
                name: "validityTo",
                label: "Érvényesség dátumáig",
                formSize: 3,
                formType: "date"
            },
            {
                name: "rowBreak1",
                label: "rowBreak1",
                rowBreak: true,
                formSize: 3,
                visibility: false,
                formVisible: true
            },
            {
                name: "sex",
                label: "Nem",
                formSize: 3,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getSexOptions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "rowBreak2",
                label: "rowBreak2",
                rowBreak: true,
                formSize: 9,
                visibility: false,
                formVisible: true
            },
            {
                name: "ageFilterOperator",
                label: "Életkor operátor",
                formSize: 3,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getFilterOperators,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ageFilter",
                label: "Életkor",
                formSize: 3,
                formType: "number"
            },
            {
                name: "rowBreak3",
                label: "rowBreak3",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "bodyMassIndexOperator",
                label: "BMI operátor",
                formSize: 3,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getFilterOperators,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "bodyMassIndex",
                label: "BMI",
                formSize: 3,
                formType: "number",
                numberStep: 0.01
            }
        ],

        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "appointment",
                label: "Vizsgálat időpontja",
                slot_name: "appointment_format",
                formSize: 4,
                sort: true,
                visibility: true,
            },
            {
                name: "occupationHealthEmployability.isValid",
                label: "Érvényesség",
                visibility: true,
                sort: true
            },
            {
                name: "doctorFullName",
                label: "Orvos",
                visibility: true,
                sort: true
            },
            {
                name: "patient.name",
                label: "Páciens",
                visibility: true
            },
            /*{
                name: "treatmentType",
                label: "Kezelés",
                visibility: true
            },*/
            {
                name: "roomName",
                label: "Szoba",
                visibility: true
            },
            {
                name: "siteName",
                label: "Telephely",
                visibility: true
            },
            {
                name: "occupationHealthPartner",
                label: "FEÜ Partner",
                visibility: true,
                sort: true
            },
            {
                name: "occupationHealthPartnerSite",
                label: "FEÜ Partner telephely",
                visibility: true,
                sort: true
            },
            {
                name: "occupationHealthSiteGroup",
                label: "Munkakör",
                visibility: true,
                sort: true
            },
            {
                name: "occupationHealthEmployability.employabilityType.text",
                label: "Munkaalkalmassági vélemény típusa",
                visibility: true,
                formSize: 5
            },
            {
                name: "occupationHealthEmployability.capableStatus.text",
                label: "Alkalmasság",
                visibility: true
            },
            {
                name: "isThereRestriction",
                label: "Korlátozás",
                visibility: true
            },
            {
                name: "restrictionName",
                label: "Korlátozás típusa",
                visibility: true,
                rowBreak: true
            },

            /*{
                name: "rowBreak1",
                label: "rowBreak",
                rowBreak: true,
                formSize: 8,
                visibility: false,
                formVisible: true
            },
            {
                name: "complaints",
                label: "Panaszok",
                visibility: false,
                formVisible: true,
                formSize: 4,
                formType: "textarea"
            },
            {
                name: "rowBreak2",
                label: "rowBreak",
                rowBreak: true,
                formSize: 8,
                visibility: false,
                formVisible: true
            },
            {
                name: "bodyWeight",
                label: "Testsúly (kg)",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "number"
            },
            {
                name: "height",
                label: "Testmagasság (m)",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "number",
                numberStep: 0.01,
                viewModalShow: true
            },
            {
                name: "bodyMassIndex",
                label: "Testtömegindex",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "number",
                formReadOnly: true,
                viewModalShow: true
            },
            {
                name: "rowBreak3",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "skinAndVisibleMucosa",
                label: "Bőr és látható nyálkahártyák",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "thyroid",
                label: "Mirigyek (pajzsmirigy)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "bonesAndJoints",
                label: "Csontok és ízületek",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "flatfoot",
                label: "Lúdtalp",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "checkbox"
            },
            {
                name: "mouthNoseAndPharynxFormulas",
                label: "Száj-, orr- és garatképletek",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "toothCondition",
                label: "Fogazat",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "lungs",
                label: "Tüdő",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "heart",
                label: "Szív",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "bloodPressureMin",
                label: "Vérnyomás /min",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "number"
            },
            {
                name: "bloodPressureHgmm",
                label: "Vérnyomás Hgmm",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "number"
            },
            {
                name: "rowBreak4",
                label: "rowBreak",
                rowBreak: true,
                formSize: 8,
                visibility: false,
                formVisible: true
            },
            {
                name: "vascularSystem",
                label: "Érrendszer (variocositas, nodus)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "gastric",
                label: "Has",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "nervousSystem",
                label: "Idegrendszer",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "rowBreak6",
                label: "rowBreak",
                rowBreak: true,
                formSize: 3,
                visibility: false,
                formVisible: true
            },
            {
                name: "hearingRight",
                label: "Hallás (jobb)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "hearingLeft",
                label: "Hallás (bal)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "rowBreak7",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "seeingRight",
                label: "Látás (jobb)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "seeingLeft",
                label: "Látás (bal)",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "colorSeeing",
                label: "Színlátás",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "text"
            },
            {
                name: "rowBreak8",
                label: "rowBreak",
                rowBreak: true,
                formSize: 3,
                visibility: false,
                formVisible: true
            },
            {
                name: "resultsOfAdditionalTests",
                label: "Kiegészítő szakvizsgálatok eredményei",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea"
            },
            {
                name: "employabilityRestrictionsOpinion",
                label: "Munkaalkalmasság, korlátozások, feltételek",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea"
            },
            {
                name: "capableStatusId",
                label: "Alkalmasság",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getCapableStatus,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "capableStatus.text",
                label: "Alkalmasság",
                visibility: true,
                formVisible: false
            },
            {
                name: "validity",
                label: "Érvényesség",
                visibility: true,
                slot_name: "date_format",
                sort: true,
                formVisible: true,
                formSize: 2,
                formType: "date",
                formRequired: true
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Létrehozás időpontja",
                slot_name: "created_on_format",
                visibility: true
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }*/
        ]
    }
}
